const infoProjectBuildType = {
  // REQUEST_FORM call
  PROJECT_BUILD_INFO_CALL: "PROJECT_BUILD_INFO_CALL",
  PROJECT_BUILD_INFO_CALL_COMMIT: "PROJECT_BUILD_INFO_CALL_COMMIT",
  PROJECT_BUILD_INFO_CALL_ROLLBACK: "PROJECT_BUILD_INFO_CALL_ROLLBACK",
};

export default infoProjectBuildType;
